"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unformatAccidentals = exports.formatAccidentals = void 0;
/**
 * Converts accidentals in a string from ASCII (#|b) to extended (♭|♯)
 * @param text
 */
function formatAccidentals(text) {
    return text.replace(/[b]/g, "♭").replace(/[#]/g, "♯");
}
exports.formatAccidentals = formatAccidentals;
/**
 * Converts accidentals in a string from extended (♭|♯) to ASCII (#|b)
 * @param text
 */
function unformatAccidentals(text) {
    return text.replace(/[♭]/g, "b").replace(/[♯]/g, "#");
}
exports.unformatAccidentals = unformatAccidentals;
//# sourceMappingURL=format.js.map